//
// locale_it.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/it.json';
import localeData from "react-intl/locale-data/it.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});
